import React, { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	EnvelopesWrapper,
	NavigationWrapper,
	PickerHOC,
	TargetsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import * as S from './styles';

export const SignatureSteps = PickerHOC(
	{
		envelope: {
			sourcePath: 'envelopes',
			sourceWrapper: EnvelopesWrapper,
			arrayItemMatcher: {
				type: 'param',
				paramName: 'envelopeId',
				itemPropertyPath: 'id',
			},
		},
		target: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
		},
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
	},
	LoadingScreen,
)(() => {
	const { navigateTo, goBack } = NavigationWrapper.use();
	const { loadUserEnvelopes } = EnvelopesWrapper.use();
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const { target, user, envelope } = PickerHOC.use();
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('SignatureSteps');
	const getError = useGetError();

	// TARGET CREATION DATA
	const creationData = useMemo(
		() => target?.targetProperties?.find((x) => x.name === 'creationData')?.value,
		[target],
	);

	// NAVIGATION
	const back = async () => {
		CONFIG.routing.signatureSteps.back(goBack);
	};

	const next = async () => {
		try {
			await loadUserEnvelopes(user.id);
			setLoading('Empezando el proceso...');
			CONFIG.routing.signatureSteps.next(navigateTo);
		} catch (e) {
			setLoading(undefined);
			openModal(() => <MainModal type="error" text={getError(e)} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-SignatureSteps-KO',
			});
		}
	};

	// EFFECTS
	useEffect(() => {
		console.log('📌 user', user);
		console.log('📌 creationData', creationData);
		console.log('📌 envelope', envelope);
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper showTopSection step={6} title="Documentos y firma">
			<View innerWrapperSt>
				<S.StepWrapper>
					<S.StepWrapperItem>
						<S.StepCircle>1</S.StepCircle>
						<Text stepsSt>{t('signatureSteps.feature')}</Text>
					</S.StepWrapperItem>
					<S.StepWrapperItem>
						<S.StepCircle>2</S.StepCircle>
						<Text stepsSt>{t('signatureSteps.feature1')}</Text>
					</S.StepWrapperItem>
					{/* <S.StepWrapperItem>
						<S.StepCircle>3</S.StepCircle>
						<Text stepsSt>{t('signatureSteps.feature2')}</Text>
					</S.StepWrapperItem> */}
					<S.StepWrapperItem>
						<S.StepCircle>3</S.StepCircle>
						<Text stepsSt>{t('signatureSteps.feature3')}</Text>
					</S.StepWrapperItem>
				</S.StepWrapper>
			</View>
			<BackNextButton isBackShown={false} onClickNext={next} />
		</Wrapper>
	);
});
